// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styles-Nav-module--cls1--1RnbS","cls2":"styles-Nav-module--cls2--2ABNt styles-Nav-module--cls1--1RnbS","mobileMenuIsOpen":"styles-Nav-module--mobileMenuIsOpen--3_Q_j"};